/* eslint
    no-empty-function: "warn"
*/

import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, elementsOf } from '@shared/easyfy.core';
import { IEasyfyEvent } from '@shared/easyfy.events/easyfy.eventdata';
import Events, {
  ServiceNames
} from '@shared/easyfy.events/easyfy.eventhandler';
import { MedsEventNames } from './eventMappers/dataMapper.ga4';

namespace Meds.Modules {
  @invoke
  class BankId {

    onInit() {
      BankId.TrackSuccessfulLogin();

      globalEvent({
        type: 'click',
        event: {
          action: 'login-button-click',
          callback: BankId.OnLoginButtonClicked
        }
      });
    }

    static OnLoginButtonClicked = async (e: Event) => {
      const event: IEasyfyEvent = {
        eventName: MedsEventNames.LoginClick,
        data: {}
      };
      Events.EasyfyEventHandler.RunEvent(event);
    };

    static TrackSuccessfulLogin = async () => {
      if (document.referrer.includes('grandid') === false) {
        return;
      }

      setTimeout(() => {
        const event: IEasyfyEvent = {
          eventName: MedsEventNames.LoggedIn,
          data: {}
        };
        Events.EasyfyEventHandler.RunEvent(event);
      }, 5000);
    };
  }
}
